import { render } from "./AuthRule.vue?vue&type=template&id=7836266c&scoped=true&ts=true"
import script from "./AuthRule.vue?vue&type=script&lang=ts"
export * from "./AuthRule.vue?vue&type=script&lang=ts"

import "./AuthRule.vue?vue&type=style&index=0&id=7836266c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.3.1_@vue+comp_8f2c4c49f6fda9a4fff749d98711c87c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7836266c"]])

export default __exports__